query SupportRequestAssignees {
  supportRequestAssignees {
    id
    displayName
    email
  }
}
